export enum EngagementTheme {
  CLIMATE_CHANGE = "Climate_Change",
  WIDER_SOCIETAL_IMPACTS = "Wider_Societal_Impacts",
  HUMAN_CAPITAL = "Human_Capital",
  BOARD_EFFECTIVENESS = "Board_Effectiveness",
  EXECUTIVE_REMUNERATION = "Executive_Remuneration",
  INVESTOR_PROTECTION_AND_RIGHTS = "Investor_Protection_and_Rights",
  RISK_MANAGEMENT = "Risk_Management",
  HUMAN_AND_LABOUR_RIGHTS = "Human_and_Labour_Rights",
  CIRCULAR_ECONOMY_AND_ZERO_POLLUTION = "Circular_Economy_and_Zero_Pollution",
  PURPOSE_STRATEGY_AND_POLICIES = "Purpose_Strategy_and_Policies",
  NATURAL_RESOURCE_STEWARDSHIP = "Natural_Resource_Stewardship",
}
